import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addRecurringJobsDetailsApi,
  addJobsTypeListApi,
  getJobsTypeListApi,
  getSingleRecurringJobsDetailsApi,
  updateJobsTypeListApi,
  getSingleJobsTypeApi,
  changeJobsTypeStatusApi,
  getJobsListApi,
  addJobsApi,
  getSingleJobsApi,
  updateJobsApi,
  getRecurringResponsiblePeopleApi,
  getJobCommentsDetailsApi,
  addJobCommentsApi,
  getJobLinksDetailsApi,
  addJobLinkApi,
  getUserMapedClientJobListApi,
  checkUniqueJobTypeApi,
  shareJobsWithTeamMembersApi,
  getUserMapedClientShareJobListApi,
  getFutureJobsListApi,
  addJobsChecklistApi,
  updateJobsChecklistApi,
  getJobCheckListApi,
  getJobCheckListSingleApi,
  addJobClosureApi,
  getAllOpenJobChecklistSingleDataApi,
  getAllOpenJobChecklistApi,
  updateAllOpenJobChecklistApi,
  lockJobsChecklistApi,
  getCommentDueTomorrowJobListApi,
  getRecurringJobReportApi,
} from "@/apis/jobsApis";

import type {
  AddJobCheckListPayloadType,
  AddJobsPayload,
  AddJobsTypePayload,
  AddRecurringJobTypePayload,
  GetAllOpenJobCheckListDetailsPayloadType,
  GetAllOpenJobCheckListPayloadType,
  GetJobCheckListPayloadType,
  GetJobsListTypePayload,
  GetJobsPayload,
  GetRecurringJobsSettingPayload,
  LockJobCheckListPayloadType,
  SingleJobPayload,
  SingleJobTypePayload,
  SingleJobTypeStatusChangePayload,
  SingleRecurringJobsPayload,
  uniqueCheckJobType,
  UpdateAllOpenJobChecklistPayloadType,
  UpdateJobCheckListPayloadType,
} from "@/commonTypes/jobsType";
import type {
  AddDocumentLinkPayloadType,
  AddJobProgressCommentPayload,
  GetAllAssignedClientsOpenJobsPayloadType,
  GetAllDocumentsLinkPayloadType,
  GetJobProgressCommentsPayload,
  GetRecurringJobReportPayloadType,
  ShareJobsWithTeamMembersPayloadType,
} from "@/commonTypes/listing";

export const getJobsTypeListAction = createAsyncThunk(
  "jobs/jobsType/Listing",
  async (data: GetJobsListTypePayload) => {
    const response = await getJobsTypeListApi(data);
    return response.data;
  }
);

export const addRecurringJobsDetailsAction = createAsyncThunk(
  "jobs/RecurringJobsType",
  async (data: AddRecurringJobTypePayload) => {
    const response = await addRecurringJobsDetailsApi(data);
    return response.data;
  }
);

export const getRecurringJobsDetailsAction = createAsyncThunk(
  "jobs/singleRecurringJobs",
  async (data: GetRecurringJobsSettingPayload) => {
    const response = await getSingleRecurringJobsDetailsApi(data);
    return response.data;
  }
);

export const getSingleJobsTypeAction = createAsyncThunk(
  "jobs/jobsType/singleData",
  async (data: SingleJobTypePayload) => {
    const response = await getSingleJobsTypeApi(data);
    return response.data;
  }
);

export const addJobsTypeAction = createAsyncThunk(
  "jobs/jobsType/Add",
  async (data: AddJobsTypePayload) => {
    const response = await addJobsTypeListApi(data);
    return response.data;
  }
);

export const changeJobsTypeStatusAction = createAsyncThunk(
  "jobs/jobsType/changeStatus",
  async (data: SingleJobTypeStatusChangePayload) => {
    const response = await changeJobsTypeStatusApi(data);
    return response.data;
  }
);

export const updateJobsTypeAction = createAsyncThunk(
  "jobs/jobsType/Update",
  async (data: AddJobsTypePayload) => {
    const response = await updateJobsTypeListApi(data);
    return response.data;
  }
);

export const addJobsAction = createAsyncThunk(
  "jobs/AddJobs",
  async (data: AddJobsPayload) => {
    const response = await addJobsApi(data);
    return response.data;
  }
);

export const getJobsListAction = createAsyncThunk(
  "jobs/JobsList",
  async (data: GetJobsPayload) => {
    const response = await getJobsListApi(data);
    return response.data;
  }
);

export const getFutureJobsListAction = createAsyncThunk(
  "jobs/FutureJobsList",
  async (data: GetJobsPayload) => {
    const response = await getFutureJobsListApi(data);
    return response.data;
  }
);

export const getSingleJobsAction = createAsyncThunk(
  "jobs/singleData",
  async (data: SingleJobPayload) => {
    const response = await getSingleJobsApi(data);
    return response.data;
  }
);

export const updateJobsAction = createAsyncThunk(
  "jobs/Update",
  async (data: AddJobsPayload) => {
    const response = await updateJobsApi(data);
    return response.data;
  }
);

export const getRecurringResponsiblePeopleAction = createAsyncThunk(
  "jobs/recurringResponsiblePeople",
  async (data: SingleRecurringJobsPayload) => {
    const response = await getRecurringResponsiblePeopleApi(data);
    return response.data;
  }
);

export const getJobCommentsDetailsAction = createAsyncThunk(
  "jobs/getJobComment",
  async (data: GetJobProgressCommentsPayload) => {
    const response = await getJobCommentsDetailsApi(data);
    return response.data;
  }
);

export const addJobCommentsAction = createAsyncThunk(
  "jobs/addJobComment",
  async (data: AddJobProgressCommentPayload) => {
    const response = await addJobCommentsApi(data);
    return response.data;
  }
);

export const getJobLinksDetailsAction = createAsyncThunk(
  "jobs/getJobLinksDetails",
  async (data: GetAllDocumentsLinkPayloadType) => {
    const response = await getJobLinksDetailsApi(data);
    return response.data;
  }
);

export const addJobLinkAction = createAsyncThunk(
  "jobs/addJobLink",
  async (data: AddDocumentLinkPayloadType) => {
    const response = await addJobLinkApi(data);
    return response.data;
  }
);
export const getUserMapedClientJobListAction = createAsyncThunk(
  "jobs/getUserMapedClientJobList",
  async (data: any) => {
    const response = await getUserMapedClientJobListApi(data);
    return response.data;
  }
);

export const getUserMapedClientShareJobListAction = createAsyncThunk(
  "jobs/getUserMapedClientShareJobList",
  async (data: any) => {
    const response = await getUserMapedClientShareJobListApi(data);
    return response.data;
  }
);

export const checkUniqueJobTypeAction = createAsyncThunk(
  "jobs/checkUniqueJobType",
  async (data: uniqueCheckJobType) => {
    const response = await checkUniqueJobTypeApi(data);
    return response.data;
  }
);

export const shareJobsWithTeamMembersAction = createAsyncThunk(
  "jobs/shareJobs",
  async (data: ShareJobsWithTeamMembersPayloadType) => {
    const response = await shareJobsWithTeamMembersApi(data);

    return response.data;
  }
);

export const getJobChecklistDataAction = createAsyncThunk(
  "jobs/getJobChecklist",
  async (data: GetJobCheckListPayloadType) => {
    const response = await getJobCheckListApi(data);
    return response.data;
  }
);

export const getJobChecklistSingleDataAction = createAsyncThunk(
  "jobs/getSingleJobChecklist",
  async (data: GetJobCheckListPayloadType) => {
    const response = await getJobCheckListSingleApi(data);
    return response.data;
  }
);

export const addJobChecklistDataAction = createAsyncThunk(
  "jobs/addJobChecklistData",
  async (data: AddJobCheckListPayloadType) => {
    const response = await addJobsChecklistApi(data);
    return response.data;
  }
);

export const updateJobChecklistDataAction = createAsyncThunk(
  "jobs/updateJobChecklistData",
  async (data: UpdateJobCheckListPayloadType) => {
    const response = await updateJobsChecklistApi(data);
    return response.data;
  }
);

export const getAllOpenJobChecklistSingleDataAction = createAsyncThunk(
  "jobs/getAllOpenJobChecklistSingleDataAction",
  async (data: GetAllOpenJobCheckListDetailsPayloadType) => {
    const response = await getAllOpenJobChecklistSingleDataApi(data);
    return response.data;
  }
);

export const getAllOpenJobChecklistAction = createAsyncThunk(
  "jobs/getAllOpenJobChecklistAction",
  async (data: GetAllOpenJobCheckListPayloadType) => {
    const response = await getAllOpenJobChecklistApi(data);
    return response.data;
  }
);

export const addJobClosureAction = createAsyncThunk(
  "jobs/addClosure",
  async (data: any) => {
    const response = await addJobClosureApi(data);
    return response.data;
  }
);

export const updateAllOpenJobChecklistAction = createAsyncThunk(
  "jobs/updateAllOpenJobChecklistAction",
  async (data: UpdateAllOpenJobChecklistPayloadType) => {
    const response = await updateAllOpenJobChecklistApi(data);
    return response.data;
  }
);

export const lockJobChecklistDataAction = createAsyncThunk(
  "jobs/lockJobChecklistDataAction",
  async (data: LockJobCheckListPayloadType) => {
    const response = await lockJobsChecklistApi(data);
    return response.data;
  }
);

export const getCommentDueTomorrowJobListAction = createAsyncThunk(
  "jobs/getCommentDueTomorrowJobList",
  async (data: GetAllAssignedClientsOpenJobsPayloadType) => {
    const response = await getCommentDueTomorrowJobListApi(data);
    return response.data;
  }
);

export const getRecurringJobReportAction = createAsyncThunk(
  "jobs/recurringJobsReport",
  async (data: GetRecurringJobReportPayloadType) => {
    const response = await getRecurringJobReportApi(data);
    return response.data;
  }
);
